import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/VendorConfiguration";

export const getExpenseAccounts = async () => {
  return await axios.get(`${api_base_url}/GetExpenseAccounts`).then((res) => {
    return res;
  });
};

export const AddExpenseAccount = async (newExpenseAccount) => {
  const {data} = await axios.post(`${api_base_url}/AddExpenseAccount`, {
    ...newExpenseAccount,
  })
  return data;
};

export const deactivateExpenseAccount = async (ids) => {
  const {data} = await axios.delete(`${api_base_url}/DeactivateExpenseAccount`, {
    data: ids,
  });

  return data;
};

export const EditExpenseAccount = async (updateExpenseAccount) => {
  const {data} = await axios.put(`${api_base_url}/EditExpenseAccount`, updateExpenseAccount);
  
  return data;
};

export const getAutopay = async () => {
  return await axios.get(`${api_base_url}/GetAutoPay`).then((res) => {
    return res;
  });
};

export const AddAutopay = async (newAutopay) => {
  return axios.post(`${api_base_url}/AddAutoPay`, {
    ...newAutopay,
  });
};

export const deactivateAutopay = async (ids) => {
  await axios.delete(`${api_base_url}/DeactivateAutoPay`, {
    data: ids,
  });
};

export const EditAutopay = async (updateAutopay) => {
  return axios.put(`${api_base_url}/EditAutoPay`, updateAutopay);
};